import "./App.css";
import RoutePage from "./routes";

function App() {
  return <RoutePage />;
}

export default App;
